import React from 'react';
import clsx from 'clsx'
import {KTSVG} from '../../../helpers'
import {HeaderUserMenu} from '../../../partials'
import { useAuth } from '../../../../app/modules/auth/core/Auth';
import {Buffer} from 'buffer'
import { OrganizationDropdown } from '../../../partials/layout/choose-organization/OrganizationDropdown'
import {useLayout} from '../../core'

const itemClass = 'ms-1 ms-lg-3'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'

const Navbar = () => {
  const {config} = useLayout()
  const {currentUser, logout} = useAuth()
  const user = Array.isArray(currentUser) && currentUser.length > 0 ? currentUser[0] : currentUser;

  if (typeof user.Foto_profilo === 'string' && user.Foto_profilo.startsWith('data:image')) {
    // Abbiamo già una data URL valida: non fare nulla
  } else if (user.Foto_profilo?.data) {
    // Abbiamo un buffer in user.Foto_profilo.data
    const arrayBuffer = user.Foto_profilo.data
    const base64String = Buffer.from(arrayBuffer).toString('base64')
    user.Foto_profilo = `data:image/png;base64,${base64String}`
  } else {
    // Nessuna immagine, quindi placeholder
    user.Foto_profilo = '/media/avatars/blank_2.png'
  }

  return (
    <div className='app-navbar flex-shrink-0'>
      
      {/* Menù a tendina per selezionare l'organizzazione */}
      <div className={clsx('app-navbar-item', itemClass)}>
        <OrganizationDropdown />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img alt='Logo' src={user.Foto_profilo} />
        </div>
        <HeaderUserMenu />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  )
}

export {Navbar}
